<template>
  <div class="title-container">
    <div class="title-content">
      <img :src="imageSrc" class="title-image" />
      <p class="title-text">{{ title }}</p>
      <div class="title-line"></div>
    </div>
  </div>
</template>
  <script>
  export default {
    props: {
      imageSrc: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      }
    }
  }
  </script>
  
  <style scoped lang="less">



  .title-container {
    display: flex;
  }

  .title-content {
    display: flex;
    position: relative;
    align-items: center;
    
  }

  .title-image {
    width: 54px;
    height: 54px;
    margin-bottom: -18px;
  }

  .title-text {
    font-family: 'PingFang SC', sans-serif;
    font-weight: 500;
    font-size: 44px;
    color: #262626;
    margin-left: 20px;
    /* 文字与图片之间的间距 */
    margin-bottom: 20px;
    line-height: 54px
  }

  .title-line {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    /* 使线条的宽度与 title-content 宽度一致 */
    height: 7px;
    background-color: #05BD6F;
  }

  /* 移动设备适配 */
  .mobile {
    .title-container {
      margin: 0 18px;
      /* 移动设备的左右边距为18px */
      justify-content: center;
      /* 居中对齐标题组件 */
    }

    .title-image {
      width: 24px;
      height: 24px;
      margin-bottom: 5px;
    }

    .title-text {
      font-size: 16px;
      margin-left: 4px;
      line-height: 0px;
      margin-bottom: 17px;
    }

    .title-line {
      bottom: -2px;
      height: 2px;
    }
  }
</style>
  
